import type { Service } from "../types.js";
import { getCookie } from "../internal/cookieUtils.js";

export { cleanUpPrismCookies, cleanUpPrismSingleCookies, cleanUpPrismWildCardCookies } from "./cookie-cleanup.js";

export const isUserAllowlistedForPrism = () => {
  const PRISM_BETA_ALLOWLISTED_COOKIE = "aws-prism-private-beta-allowlisted";
  const isAllowListed = getCookie(PRISM_BETA_ALLOWLISTED_COOKIE);
  return !!isAllowListed && isAllowListed === "true";
};

export const isUserOptedIntoPrism = () => {
  const PRISM_OPT_IN_COOKIE = "aws-prism-opt-in";
  const isOptedIntoPrism = getCookie(PRISM_OPT_IN_COOKIE) || "";
  return !!isOptedIntoPrism && isOptedIntoPrism === "true";
};

export const isPrismSupportedConsole = () => {
  const PRISM_UNSUPPORTED_CONSOLE_COOKIE = "aws-consoleInfo";
  const isPrismSupported = getCookie(PRISM_UNSUPPORTED_CONSOLE_COOKIE);
  return !isPrismSupported;
};

export const isPrismEnabledNonKTLOService = (service: Partial<Pick<Service, "id">>) => {
  return isUserOptedIntoPrism() && !isKTLOServiceConsole(service);
};

/* Temporarily Hande KTLO consoles */
const KTLO_CONSOLES_IDS = [
  "ops", // OpsWorks
  "robomaker", // RoboMaker
  "cs", // CloudSearch
  "ets", // Elastic Transcoder
  "ins", // Inspector
  "cc", // CodeCommit
];

const UNSUPPORTED_CONSOLES_PATH = ["/route53/trafficflow/home", "/wafv2/home", "/maxdome/home"];

export const isKTLOServiceConsole = (service: Partial<Pick<Service, "id">>) => {
  return (
    (service?.id && KTLO_CONSOLES_IDS.includes(service?.id)) ||
    UNSUPPORTED_CONSOLES_PATH.includes(window?.location?.pathname)
  );
};
